import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { incidents } from '@/mocks/incidents';

const accentStyles = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-800',
  'bg-secondary-100 text-secondary-800',
];

export default function TopicSection() {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-[0.2em] text-primary-700">风险分类</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            六类风险，各有各的破绽
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            同样是「网站有问题」，成因与应对方式差别很大。按类别看，更容易找到与自己相关的那一类。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic, index) => {
            const count = incidents.filter((item) => item.category === topic.slug).length;
            return (
              <Link
                key={topic.slug}
                to={`/topic/${topic.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 md:p-6"
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md ${accentStyles[index % accentStyles.length]}`}
                  >
                    <i className={`${topic.icon} text-xl`}></i>
                  </span>
                  <span className="rounded-full border border-background-300 px-2.5 py-1 text-[11px] text-foreground-500">
                    {count} 篇收录
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{topic.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{topic.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-700">
                  进入分类
                  <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}